import React from 'react';

export const Highlighter = ({
  highlight,
  value,
}: {
  highlight: string;
  value: string;
}) => {
  return (
    <div
      style={{
        color: 'transparent',
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word',
        overflow: 'hidden',
      }}
    >
      {getHighlightedText(value, highlight)}
    </div>
  );
};

function getHighlightedText(text: string, highlight: string) {
  // Split text on higlight term, include term itself into parts, ignore case
  if (!text) return;
  if (!highlight) return;
  const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
  return parts.map((part, index) => (
    <React.Fragment key={index}>
      {part.toLowerCase() === highlight.toLowerCase() ? (
        <mark
          style={{
            backgroundColor: '#e8bb49',
            color: 'transparent',
            padding: 0,
          }}
        >
          {part}
        </mark>
      ) : (
        part
      )}
    </React.Fragment>
  ));
}
